type TurnstileRenderOptions = {
  sitekey: string;
  theme?: "auto" | "light" | "dark";
  callback?: (token: string) => void;
  "expired-callback"?: () => void;
  "error-callback"?: () => void;
};

export type TurnstileApi = {
  render(container: HTMLElement, options: TurnstileRenderOptions): string;
  reset(widgetId?: string): void;
};

declare global {
  interface Window {
    turnstile?: TurnstileApi;
  }
}

let turnstilePromise: Promise<TurnstileApi> | null = null;

export function loadTurnstile(siteKey: string): Promise<TurnstileApi> {
  if (!siteKey.trim()) {
    return Promise.reject(new Error("Отсутствует VITE_TURNSTILE_SITE_KEY."));
  }

  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (turnstilePromise) {
    return turnstilePromise;
  }

  turnstilePromise = new Promise<TurnstileApi>((resolve, reject) => {
    const existingScript = document.querySelector<HTMLScriptElement>('script[data-cg-turnstile="true"]');
    if (existingScript) {
      existingScript.addEventListener("load", handleLoad, { once: true });
      existingScript.addEventListener("error", handleError, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.dataset.cgTurnstile = "true";
    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });
    document.head.appendChild(script);

    function handleLoad() {
      if (!window.turnstile) {
        reject(new Error("Turnstile загрузился некорректно."));
        return;
      }

      resolve(window.turnstile);
    }

    function handleError() {
      reject(new Error("Не удалось загрузить Cloudflare Turnstile."));
    }
  }).catch((error) => {
    turnstilePromise = null;
    throw error;
  });

  return turnstilePromise;
}
